module.exports = {
	"nl": {
		"(Will be) delivered": "Wordt geleverd",
		"(Will be) partially delivered": "Wordt deels geleverd",
		"(excl. btw - {{d.promoCode}} - Valid until {{d.endDate | date: 'dd/MM/yyyy'}})": "(excl. btw - {{d.promoCode}} - Geldig tot {{d.endDate | date: 'dd/MM/yyyy'}})",
		".csv file, max. 5MB": "CSV-bestand, max. 5MB",
		"<a href=\"http://www.profficina.be\" target=\"_blank\" class=\"link\">www.profficina.be</a>": "<a href=\"http://www.profficina.be\" target=\"_blank\" class=\"link\">www.profficina.be</a>",
		"<a href=\"http://www.profficina.be/nl/algemene-voorwaarden.html\" target=\"_blank\" class=\"link\">Terms and conditions</a>": "<a href=\"http://www.profficina.be/nl/algemene-voorwaarden.html\" target=\"_blank\" class=\"link\">Algemene gebruiksvoorwaarden</a>",
		"<a href=\"http://www.profficina.be/nl/privacy-beleid.html\" target=\"_blank\" class=\"link\">Privacy policy</a>": "<a href=\"http://www.profficina.be/nl/privacy-beleid.html\" target=\"_blank\" class=\"link\">Privacy beleid</a>",
		"<b>Niet te reserveren</b>": "<b>Niet te reserveren.</b>",
		"<b>Zonder korting</b>": "<b>Te reserveren zonder korting.</b>",
		"<strong>Do not order</strong> the products.": "de producten <strong>niet te bestellen</strong>.",
		"<strong>Opgelet!</strong> Geen retours mogelijk. Levering van zodra voorradig en zolang de voorraad strekt.": "<strong style=\"color: #82BC00;\">Opgelet!</strong> Geen retours mogelijk. Levering van zodra voorradig en zolang de voorraad strekt.",
		"<strong>Opgelet!</strong> U kan na 28 februari 2021 uw gereserveerde aantallen niet meer wijzigen.": "<strong style=\"color: #82BC00;\">Opgelet!</strong> U kan na 28 februari 2021 uw gereserveerde aantallen niet meer wijzigen.",
		"<strong>Opgelet!</strong> het maximale reservatieniveau voor de Influvac vaccins werd bereikt. Het is dus niet meer mogelijk om deze te reserveren. U kan uw eerder gereserveerde Influvac vaccins wel nog raadplegen, maar niet langer wijzigen.": "<strong  style=\"color: #82BC00;\">Opgelet!</strong> het maximale reservatieniveau voor de Influvac vaccins werd bereikt. Het is dus niet meer mogelijk om deze te reserveren. U kan uw eerder gereserveerde Influvac vaccins wel nog raadplegen, maar niet langer wijzigen.",
		"<strong>Order</strong> the products <strong>anyway</strong> via the customer service ('special order').": "De producten <strong>bestellen</strong> via de klantendienst (‘Speciale bestellingen’). ",
		"A question? A suggestion?": "Een vraag? Een suggestie?",
		"ALPHARIX TETRA 2020-2021 0,5 ML 1 WWSP": "ALPHARIX TETRA 2020-2021 0,5 ML 1 WWSP",
		"APB category": "APB categorie",
		"APB-number": "Vergunningsnummer",
		"About us": "Over ons",
		"Access is denied": "Toegang geweigerd",
		"Account": "Account",
		"Active ingredients": "Actieve bestandsdelen",
		"Add": "Toevoegen",
		"Add package": "Verzending toevoegen",
		"Add products or import a CSV file with your order.": "Geef producten in of importeer een csv-bestand met uw bestelling.",
		"Add to shopping cart": "In winkelmand",
		"Add {{ vm.product.quantityToAddForHighestDiscount }} pcs. for {{ vm.product.highestDiscount.discount }}% discount": "Voeg {{ vm.product.quantityToAddForHighestDiscount }} stuks toe voor {{ vm.product.highestDiscount.discount }}% korting",
		"Added products to your shoppingcart": "De producten zijn toegevoegd aan uw winkelmand.",
		"Address": "Adres",
		"Al mijn verzendingen": "Al mijn verzendingen",
		"All categories": "Alle categorieën",
		"All discounts": "Alle kortingen",
		"All my rental requests": "Al mijn huuraanvragen",
		"All my rented products": "Al mijn huurproducten",
		"All news": "Alle nieuws",
		"All partnerships": "Alle partners",
		"All pharmacies": "Alle apotheken",
		"All products": "Alle producten",
		"All products of this supplier or in your contract.": "Alle producten van deze leverancier zitten in uw contract.",
		"All rental products": "Alle huurproducten",
		"All sellers": "Alle aanbieders",
		"All vendors": "Alle aanbieders",
		"Amount": "Bedrag",
		"An error occured when adding products to your shoppingcart, please try again": "Er is iets foutgelopen, probeer het a.u.b. opnieuw",
		"An error occurred during the confirmation of the order. Please contact the customer support.": "Er heeft zich een onverwacht probleem voorgedaan tijdens de bevestiging van uw order. Neem aub contact op met de klantendienst. Onze excuses voor het ongemak.",
		"An error occurred during the re order. Please contact the customer support.": "Er heeft zich een onverwacht probleem voorgedaan tijdens de bevestiging van uw order. Neem aub contact op met de klantendienst. Onze excuses voor het ongemak.",
		"An overview of all rental products since 2019.": "Een overzicht van alles wat u huurde sinds 2019.",
		"Are you sure you want to clear your shopping cart?": "Bent u zeker dat u uw winkelmand wil leegmaken?",
		"At least": "Minstens",
		"Attention!": "Opgelet!",
		"Available": "Voldoende voorraad",
		"Back to overview": "Terug naar overzicht",
		"Batch number": "Lot",
		"Below are some useful links:": "Hieronder vindt u enkele handige links:",
		"Bewaren": "Bewaren",
		"Billing address": "Facturatieadres",
		"Black Friday": "Black Friday",
		"Box.": "Bus",
		"Box:": "Bus: ",
		"Box: {{vm.partnership.partner.address.boxNumber}}": "Bus: {{vm.partnership.partner.address.boxNumber}}",
		"Brand": "Merk",
		"Brands": "Merken",
		"Buy": "Bestellen",
		"CNK": "CNK",
		"CTI extended": "CTI extended",
		"Call": "Bel naar",
		"Cancel": "Annuleren",
		"Cancelled": "Geannuleerd",
		"Categories": "Categorieën",
		"Categorisation": "Categorisatie",
		"Certificates": "Certificaten",
		"Certificates headerlink": "Analyse<br />certificaten",
		"Certificates introtext": "<p>Bij elk grondstof hoort een analysecertificaat, zo ook bij <strong>Febelcare Elements</strong>. <strong>Dankzij Profficina</strong> heeft u altijd en overal <strong>toegang tot deze certificaten!</strong></p><p>Een analysecertificaat opvragen doet u eenvoudigweg door het lotnummer, het CNK of de productnaam op de verpakking hieronder in te geven. Het kan zijn dat er geen lotnummer gevonden wordt. Dit betekent dat het nummer vervallen is of dat het certificaat gewoonweg niet is opgenomen in de database.</p><p>Bij eventuele problemen, kunt u steeds terecht bij onze klantendienst. Zij helpen u graag verder.</p>",
		"Certificates title": "Op zoek naar een analysecertificaat?",
		"Change": "Wijzigen",
		"Check stock": "Raadpleeg voorraad",
		"Check your order": "Kijk uw bestelling na",
		"Checking stock...": "Voorraad wordt gecheckt",
		"City": "Stad",
		"Clear": "Wissen",
		"Clear all": "Alles wissen",
		"Clear all filters": "Alle filters verwijderen",
		"Clear selection": {
			"Datetimepicker tooltips": "Wissen"
		},
		"Clear shopping cart": "Winkelmand leegmaken",
		"Click here to see the complete list.": "Klik hier om de volledige lijst te zien.",
		"Close": "Sluiten",
		"Close and don't show again": "Niet meer weergeven",
		"Close the picker": {
			"Datetimepicker tooltips": "Kalender sluiten"
		},
		"Company number": "Ondernemingsnummer",
		"Compose your panacea by choosing products from the list below.": "Stel uw panaché samen aan de hand van de producten uit onderstaande lijst.",
		"Composition": "Samenstelling",
		"Confirm": "Bevestigen",
		"Confirm order": "Bestelling bevestigen",
		"Confirmation": "Bevestiging",
		"Conservation": "Bewaring",
		"Contact": {
			"$$noContext": "Contact",
			"Contact page title": "Contact"
		},
		"Contact person": "Contactpersoon",
		"Contacts": "Contactpersonen",
		"Continue shopping": "Verder winkelen",
		"Continue without updating cart": "Verdergaan zonder winkelmand aan te passen",
		"Contra indication": "Contra-indicatie",
		"Contract name": "Contract naam",
		"Contracts": "Contracten",
		"Counter discount": "Tellerkorting",
		"Created": "Gecreëerd",
		"Current discount": "Huidige korting",
		"Current filters": "Huidige filters",
		"Currently you do not have any Febelco Partner or Agios contract.": "U heeft nog geen contract voor dit partnership.",
		"Customer number": "Klantnummer",
		"DD-MM-YYYY": "DD-MM-JJJJ",
		"Date": "Datum",
		"De minimumhuurtijd bedraagt 7 kalenderdagen. Er worden €60 transportkosten (AP excl BTW) aangerekend; deze kost omvat leveren, ophalen, reiniging en de administratieve afhandeling. ESRI zal niets factureren aan de patiënt. Alle facturatie verloopt via uw apotheek.": "De minimumhuurtijd bedraagt 7 kalenderdagen. Er worden €60 transportkosten (AP excl BTW) aangerekend; deze kost omvat leveren, ophalen, reiniging en de administratieve afhandeling. ESRI zal niets factureren aan de patiënt. Alle facturatie verloopt via uw apotheek.",
		"Decrement Hour": {
			"Datetimepicker tooltips": "Uur verlagen"
		},
		"Decrement Minute": {
			"Datetimepicker tooltips": "Minuten verlagen"
		},
		"Decrement Second": {
			"Datetimepicker tooltips": "Seconden verlagen"
		},
		"Deficit": "Tekort",
		"Delayed deliveries": "Volgende bestellingen worden later geleverd",
		"Delete": "Verwijderen",
		"Deliver earlier": "Leveringsdatum vervroegen",
		"Delivered": "Geleverd",
		"Deliveries": "Leveringen",
		"Delivery Date": "Levering na",
		"Delivery address": "Leveringsadres",
		"Delivery nr.": "Leveringsnr.",
		"Deposit": "Waarborg",
		"Deposit not refunded": "Waarborg niet terugbetaald",
		"Deposit refunded": "Waarborg terugbetaald",
		"Deposit:": "Waarborg:",
		"Depth": "Diepte",
		"Description": "Beschrijving",
		"Detail": "Detail",
		"Diameter": "Diameter",
		"Dimensions": "Afmetingen",
		"Discount": "Korting",
		"Discount date": "Datum korting",
		"Discount expires today": "Korting vervalt vandaag",
		"Discount on order total": "Korting op totale bestelling",
		"Discount on total order at": "Korting op totale bestelling bij",
		"Discount type": "Korting",
		"Discounts": "Kortingen",
		"Discounts only": "Enkel kortingen",
		"Discover all promotions!": "Ontdek alle promoties!",
		"Discover the <a class=\"link-primary\" ui-sref=\"seller.rentProductOverview({sellerId: vm.tgzId})\">Homecare rental range</a>.": "Ontdek het <a class=\"link-primary\" ui-sref=\"seller.rentProductOverview({sellerId: vm.tgzId})\">Thuisgezondheidszorg huuraanbod</a>.",
		"Displayname": "Weergave naam",
		"Displays": "Displays",
		"Dit product wordt rechtstreeks geleverd bij de patiënt.": "Dit product wordt rechtstreeks geleverd bij de patiënt.",
		"Document (pdf)": "Document (pdf)",
		"Document library": "Infotheek",
		"Documents": "Documenten",
		"Download PDF": "Download PDF",
		"Drag your file here or": "Sleep je bestand naar hier of",
		"Dutch": "Nederlands",
		"E-mail address and language for order confirmations:": "E-mailadres en taal bevestigingsmails bestelling:",
		"Email address": "E-mailadres",
		"Enkel te bestellen via uw vertegenwoordiger": "Enkel te bestellen via uw vertegenwoordiger",
		"Enter e-mailadress": "Vul e-mailadres in",
		"Error": "Fout",
		"Estimated Delivery Date": "Verwachte levertijd",
		"Expected delivery date": "Verwachte leveringsdatum",
		"Expires": "Vervalt",
		"Expires within {{productDiscount.daysLeft}} days": "Vervalt binnen {{productDiscount.daysLeft}} dagen",
		"Expires within {{vm.product.daysLeftUntilDiscountExpires}} days": "Vervalt binnen {{vm.product.daysLeftUntilDiscountExpires}} dagen",
		"Expiry date": "Vervaldatum",
		"Extra info": "Extra info",
		"FAQ": "Veelgestelde vragen",
		"Fast Order": "Snel bestellen",
		"Fast order": "Snel bestellen",
		"Fax:": "Fax:",
		"Featured products": "Producten in de kijker",
		"Febelco stock info": "Febelco voorraad info",
		"Filter": "Filter",
		"Flu vaccines": "GRIEPVACCINS",
		"Following products can be ordered via 'special order', should the product not be in stock at the moment.": "Indien de volgende producten niet meer op stock zijn, kunt u ze bestellen via ‘Speciale bestellingen’.",
		"For more information about this contract, please contact your relationship manager.": "Voor bijkomende informatie betreffende dit contract kan u terecht bij uw relatiebeheerder.",
		"For more information about this contract, please contact your supplier.": "Voor bijkomende informatie betreffende dit contract kan u terecht bij uw leverancier.",
		"French": "Frans",
		"Frequently asked questions": "Veelgestelde vragen",
		"From": "Van",
		"From date must be greater than contract start date.": "Startdatum moet groter of gelijk zijn aan startdatum contract.",
		"From&nbsp;{{vm.product.minOrderAmount}}": "Vanaf&nbsp;{{vm.product.minOrderAmount}}",
		"GPM": "BWM",
		"Gelieve hieronder in te geven waar de producten geleverd mogen worden en wie ESRI kan contacteren om te verwittigen w.b. de levering.": "Gelieve hieronder in te geven waar de producten geleverd mogen worden en wie ESRI kan contacteren om te verwittigen w.b. de levering.",
		"General": "Algemeen",
		"Go to today": {
			"Datetimepicker tooltips": "Vandaag"
		},
		"Griepvaccins 2021-2022": "Griepvaccins 2021-2022",
		"Gross profit margin": "Brutowinstmarge",
		"Gross profit margins (GPM) are calculated based on the pharmacy and public price (non-binding recommended prices).": "Brutowinstmarges (BWM) worden berekend op basis van de apothekers- en publieksprijs (niet-bindende adviesprijzen).",
		"Height": "Hoogte",
		"Hello": "Dag",
		"Help": "Veelgestelde vragen",
		"Hier krijgt u een overzicht van alle Thuisgezondheidszorg producten in uw bezit en alle huuraanvragen via Profficina.": "Hier krijgt u een overzicht van alle Thuisgezondheidszorg producten in uw bezit en alle huuraanvragen via Profficina.",
		"Hier krijgt u een overzicht van alle bestellingen die u bij Profficina geplaatst heeft.": "Hier krijgt u een overzicht van alle bestellingen die u bij Profficina geplaatst heeft.",
		"Hier krijgt u een overzicht van alle producten die u bij Febelco gereserveerd heeft.": "Hier krijgt u een overzicht van alle producten die u bij Febelco gereserveerd heeft.",
		"Hieronder kan u uw reservatie van de afgelopen 12 maanden terugvinden. Gelieve met uw klantendienst contact op te nemen indien u een reservatie wenst te annuleren.": "Hieronder kan u uw reservatie van de afgelopen 12 maanden terugvinden. Gelieve met uw klantendienst contact op te nemen indien u een reservatie wenst te annuleren.",
		"Home": "Home",
		"Homepage": "Startpagina",
		"How can you enjoy this partnership?": "Hoe kunt u van dit voordeel genieten?",
		"INFLUVAC S 2020-2021 0,5 ML 1 WWSP": "INFLUVAC S 2020-2021 0,5 ML 1 WWSP",
		"In progress": "In behandeling",
		"In the spotlight": "In de kijker",
		"Increment Hour": {
			"Datetimepicker tooltips": "Uur verhogen"
		},
		"Increment Minute": {
			"Datetimepicker tooltips": "Minuten verhogen"
		},
		"Increment Second": {
			"Datetimepicker tooltips": "Seconden verhogen"
		},
		"Indication": "Indicatie",
		"Influvac niet meer reserveerbaar na bericht van de leverancier op 1/4/20.": "Influvac niet meer reserveerbaar na bericht van de leverancier op 1/4/20.",
		"Info": "Info",
		"Invoiced": "Gefactureerd",
		"Just a moment please, your order is being added to your shopping cart...": "Even geduld, de producten worden toegevoegd aan uw winkelmand...",
		"Just a moment please, your order is being processed...": "Even geduld, uw import wordt verwerkt... ",
		"Klaar voor de winter?": "Klaar voor de winter?",
		"Language": "Taal",
		"Learn more": "Meer info",
		"Lees meer": "Lees meer",
		"Limited stock!": "Beperkte voorraad!",
		"Location": "Plaats",
		"Log in": "Aanmelden",
		"Log in with other pharmacy:": "Aanmelden met een andere apotheek",
		"Max": "Max",
		"Max. discount": "Max. korting",
		"Media": "Media",
		"Meer Details": "Meer Details",
		"Mijn verzendingen": "Mijn verzendingen",
		"Mijn verzendingen bekijken": "Mijn verzendingen bekijken",
		"Mocht u verdere vragen hebben, kan u steeds terecht bij uw vertrouwde relatiebeheerder.": "Mocht u verdere vragen hebben, kan u steeds terecht bij uw vertrouwde relatiebeheerder.",
		"Modify": "Aanpassen",
		"Modify password": "Wachtwoord wijzigen",
		"Month": [
			"maand",
			"maanden"
		],
		"More info": "Meer informatie",
		"More info about": "Meer informatie over",
		"More info about 'special orders'.": "Meer informatie over 'Speciale bestellingen'.",
		"More than one pharmacy is linked to your account. Choose the pharmacy you wish to log on with.": "Er zijn meerdere apotheken gelinkt aan uw account. Kies met welke apotheek u wil aanmelden.",
		"More than one seller is linked to your account. Choose the seller you wish to log on with.": "Er zijn meerdere aanbieders gelinkt aan uw account. Kies met welke aanbieder u wil aanmelden.",
		"My account": "Mijn account",
		"My contracts": "Mijn contracten",
		"My log in data": "Mijn aanmeldgegevens",
		"My orders": "Mijn bestellingen",
		"My packages": "Mijn verzendingen",
		"My pharmacy": "Mijn apotheek",
		"My rent overview": "Mijn huuroverzicht",
		"My reservations": "Mijn reservaties",
		"Febelco organiseert naar jaarlijkse gewoonte een voorverkoop van griepvaccins, en dat tot en met 28 februari 2021.": "Febelco organiseert naar jaarlijkse gewoonte een voorverkoop van griepvaccins, en dat tot en met 28 februari 2021.",
		"Name": "Naam",
		"Name or APB or client number": "Naam of APB of klantnummer",
		"New order date must be before current order date": "Nieuwe leveringsdatum moet vroeger zijn dan de verwachte leveringsdatum ",
		"New order date must be later than today": "Nieuwe leveringsdatum moet na vandaag zijn",
		"Newest": "Nieuwste",
		"News": "Nieuws",
		"News for": "Nieuws voor",
		"News overview cannot be shown": "Het nieuws overzicht is niet beschikbaar.",
		"Next": "Volgende",
		"Next Century": {
			"Datetimepicker tooltips": "Volgende eeuw"
		},
		"Next Decade": {
			"Datetimepicker tooltips": "Volgend decennium"
		},
		"Next Month": {
			"Datetimepicker tooltips": "Volgende maand"
		},
		"Next Year": {
			"Datetimepicker tooltips": "Volgend jaar"
		},
		"No": "Nee",
		"No certificates found for the given search criteria.": "Geen certificaat gevonden voor de ingegeven zoekcriteria.",
		"No orders found": "Geen resultaten.",
		"No passed rental products the last 3 months.": "U hebt de voorbije 3 maanden geen huur stopgezet.",
		"No products found.": "Geen producten gevonden.",
		"No results.": "Geen resultaten.",
		"No stock available": "Niet voorradig",
		"Non Rental Products": "Gekochte producten",
		"Non-binding recommended prices": "Niet-bindende adviesprijzen",
		"Not available": "Niet beschikbaar",
		"Note": "Opmerking",
		"Notices": "Bijsluiters",
		"Notices for patient": "Bijsluiter voor patiënt",
		"N°": "N°",
		"N° displays": "Aantal displays",
		"OP=OP": "OP=OP",
		"One or more products were not found": "Eén of meer producten werd niet gevonden",
		"Only {{productDiscount.counter}} piece(s) left!": "Slechts {{productDiscount.counter}} stuk(s) beschikbaar",
		"Only {{vm.counter}} piece(s) left!": "Slechts {{vm.counter}} stuk(s) beschikbaar",
		"Onze externe partner, ESRI, kan pas 24u na het moment van aanvraag leveren. Wenst u een dringende aanvraag (bijv. voor een palliatieve patiënt), neem dan even contact met de thuiszorgafdeling van Febelco via tgz@febelco.be of via het nummer 03/292.24.72. Zij bekijken dan samen met de externe partner wat er mogelijk is.": "Onze externe partner, ESRI, kan pas 24u na het moment van aanvraag leveren. Wenst u een dringende aanvraag (bijv. voor een palliatieve patiënt), neem dan even contact met de thuiszorgafdeling van Febelco via tgz@febelco.be of via het nummer 03/292.24.72. Zij bekijken dan samen met de externe partner wat er mogelijk is.",
		"Op {{vm.rentedProductsOrder.deliveryInfo.deliveryDate | date}} zullen de product(en) geleverd worden op uw gekozen leveradres": "Op {{vm.rentedProductsOrder.deliveryInfo.deliveryDate | date}} zullen de product(en) geleverd worden op het door u gekozen leveradres.",
		"Op=Op? These is the last stock for certain products for an extra discounted price. These products can not be returned.": "Op=op? Dat zijn de laatste stuks van producten aan een extra voordelige prijs. Elke maand zijn er nieuwe aanbiedingen, kom dus regelmatig een kijkje nemen! De producten kunnen niet geretourneerd worden.",
		"Opgelet, de aangeduide aantallen griepvaccins op deze pagina geven uw initiële, totale reservatie griepvaccins weer. De aantallen houden met andere woorden geen rekening met eventueel reeds geleverde griepvaccins.": "Opgelet, de aangeduide aantallen griepvaccins op deze pagina geven uw initiële, totale reservatie griepvaccins weer. De aantallen houden met andere woorden geen rekening met eventueel reeds geleverde griepvaccins.",
		"Order": {
			"$$noContext": "Bestelling",
			"verb": "Bestellen",
			"noun": "Bestelling"
		},
		"Order - noun": "Bestelling",
		"Order confirmation": "Bestelling bevestigen",
		"Order here": "Bestel hier",
		"Order now": "Nu bestellen",
		"Order pack": "Promopack bestellen",
		"Order panaché": "Bekijk de panaché condities en bestel",
		"Order total": "Totaal bestelling",
		"Order total price": "Korting op totale bestelling",
		"Ordered products": "Producten",
		"Orders are pharmacy based. When you log on as another pharmacy, your shopping basket will change. Your current shopping basket is however not removed.": "Bestellingen gebeuren per apotheek. Als u aanmeldt met een andere apotheek zal uw winkelmand wijzigen. Uw huidig winkelmand wordt echter niet verwijderd.",
		"Orders in Profficina are pharmacy based. Once logged on, you can always switch pharmacy through the 'My account' link in the menu.": "Bestellingen in Profficina gebeuren per apotheek. Eens aangemeld, kan u steeds wisselen van apotheek via de link 'Mijn account' in het menu.",
		"Other offers with this product": "Andere aanbiedingen met dit product",
		"Our website uses cookies to make your browsing experience better. By using our site, you agree to our use of cookies.": "Onze website maakt gebruik van cookies om uw gebruikservaring te verbeteren. Door onze website te gebruiken, gaat u akkoord met het gebruik van deze cookies.",
		"Outlet": "Op=Op",
		"Overview": "Overzicht",
		"Overview all discounts": "Overzicht alle kortingen",
		"Overzicht producten in reservatie": "Overzicht producten in reservatie",
		"PDF": "PDF",
		"PROMO": "PROMO",
		"Package quantity": "Verpakkingshoeveelheid",
		"PackageDetail": "Details verzending",
		"Packages archive": "Al mijn verzendingen",
		"Panaché": "Panaché",
		"Panaché:": "Panaché",
		"Partially in progress by wholesaler": "Deels in behandeling",
		"Partially invoiced": "Deels gefactureerd",
		"Partially registered by wholesaler": "Deels geregistreerd",
		"Partnerships": "Partnerships",
		"Password": "Wachtwoord",
		"Pharmacy": "Apotheek",
		"Pharmacy price": "Apothekersprijs",
		"Pick Hour": {
			"Datetimepicker tooltips": "Kies uur"
		},
		"Pick Minute": {
			"Datetimepicker tooltips": "Kies minuten"
		},
		"Pick Second": {
			"Datetimepicker tooltips": "Kies seconden"
		},
		"Place order": "Bestelling plaatsen",
		"Please enter a date before {{vm.maxDate | date: 'dd-MM-yyyy'}}": "Gelieve een datum te kiezen voor {{vm.maxDate | date: 'dd-MM-yyyy'}}",
		"Please enter a date in the future": "Gelieve een datum die in de toekomst ligt op te geven",
		"Please enter a quantity.": "Vul een aantal in.",
		"Please place your order within {{error.daysLeftUntilDiscountExpires}} days, discount for {{error.productName}} ends on {{error.expireDate | date:'yyyy-MM-dd'}}": "Gelieve binnen de {{error.daysLeftUntilDiscountExpires}} dagen te bestellen, de korting op {{error.productName}} vervalt op {{error.expireDate | date:'yyyy-MM-dd'}}",
		"Please provide a street.": "Gelieve een geldige straat te selecteren",
		"Please provide a valid city.": "Gelieve een geldige stad te selecteren.",
		"Please provide your contact person.": "Gelieve een contactpersoon op te geven.",
		"Please provide your housenumber.": "Gelieve uw huisnummer in te vullen.",
		"Please provide your telephone number.": "Gelieve uw telefoonnummer in te vullen.",
		"Please refine your search.": "Verfijn uw zoekopdracht...",
		"Please select a pharmacy": "Selecteer een apotheek",
		"Please select a seller": "Selecteer een aanbieder",
		"Prescription": "Op voorschrift",
		"Previous": "Vorige",
		"Previous Century": {
			"Datetimepicker tooltips": "Vorige eeuw"
		},
		"Previous Decade": {
			"Datetimepicker tooltips": "Vorig decennium"
		},
		"Previous Month": {
			"Datetimepicker tooltips": "Vorige maand"
		},
		"Previous Year": {
			"Datetimepicker tooltips": "Vorig jaar"
		},
		"Price": "Prijs",
		"Price information": "Prijsinformatie",
		"Price:": "Prijs:",
		"Processing...": "Aan het verwerken…",
		"Product": "Product",
		"Product available": "Voorradig",
		"Product discount": "Productkorting",
		"Product info": "Product info",
		"Product information": "Productinformatie",
		"Product name or number": "Productnaam of nummer",
		"Product name, number or lot number": "CNK, productnaam of lotnummer",
		"Product not found": "Er werd geen product gevonden met dit Productnummer.",
		"Product number": "CNK",
		"Product number or product name": "CNK of productnaam",
		"Product number, name product": "CNK of productnaam",
		"Product overview cannot be shown": "Het product overzicht is niet beschikbaar",
		"Product status": "Product status",
		"active": "Actief",
		"inactive": "Niet actief",
		"true": "Ja",
		"false": "Nee",
		"Written request by patient": "Schriftelijke aanvraag",
		"Product vervalt op {{productDiscount.expirationDate | date: 'dd/MM/yyyy'  }}": "Product vervalt op {{productDiscount.expirationDate | date: 'dd/MM/yyyy'  }}",
		"ProductNumber": "Productnummer",
		"Producten die mogelijks\n                                            interessant zijn om bij te huren": "Producten die mogelijks\n interessant zijn om bij te huren",
		"Producten die mogelijks\n                                            interessant zijn om bij te kopen": "Producten die mogelijks\n interessant zijn om bij te huren",
		"Producten die mogelijks interessant zijn om bij te huren": "Producten die mogelijks interessant zijn om bij te huren",
		"Producten die mogelijks interessant zijn om bij te kopen": "Producten die mogelijks interessant zijn om bij te kopen",
		"Productname or product number": "Productnaam of Productnummer",
		"Products": "Producten",
		"Products were added to your cart": "Producten succesvol toegevoegd aan winkelmand.",
		"Profficina": "Profficina",
		"Profficina Ref.": "Profficina ref.",
		"Profficina ref.": "Profficina ref.",
		"Profficina ref. or TO-nr.": "Profficina ref. of TO-bonnr.",
		"Promopack": "Promopack",
		"Properties": "Eigenschappen",
		"Public categories": "Publieke categorieën",
		"Public price": "Publieksprijs",
		"Quantity": "Aantal",
		"Quantity in panaché": "Aant. in panaché",
		"Quantity:": "Aantal:",
		"Questions or remarks concerning the pharmacovigilance of one of our products?": "Vragen of opmerkingen wat betreft de <br />pharmacovigilantie van onze producten?",
		"Questions? More info?": "Vragen? Meer informatie?",
		"Read more": "Lees meer",
		"Read our FAQ": "Raadpleeg onze veelgestelde vragen",
		"Receipt": "Bestelnota",
		"Recently passed rental products": "Recent huur gestopt",
		"Reference codes": "Referentiecodes",
		"Refund value with omnio": "Omnio tarief",
		"Refund value without omnio": "Terugbetalingstarief",
		"Refunded deposit": "Waarborg terug",
		"Registered": "Geregistreerd",
		"Registered by seller": "Geregistreerd door aanbieder",
		"Related news": "Verwant nieuws",
		"Rent": {
			"Verb": "Huur"
		},
		"Rent per day": "Huur per dag",
		"Rent per day:": "Huur per dag:",
		"Rent products": "Huurproducten",
		"Rental amount per month": "Huur per maand",
		"Rental products": "Huurproducten",
		"Rental products in your possession": "Huurproducten in uw bezit",
		"Rental request (Pdf)": "Aanvraag (PDF)",
		"Rental service": "Verhuur",
		"Rented from": "Gehuurd sinds",
		"Rented product detail": "Detail huurproduct",
		"Rented since – until": "Gehuurd sinds &ndash; tot",
		"Rented until": "Gehuurd tot",
		"Rented until – from": "Gehuurd sinds &ndash; tot",
		"Reorder": "Bestel opnieuw",
		"Replacement product available": "Vervangend product voorradig",
		"Required&nbsp;{{vm.product.minOrderAmount}}": "Verplicht&nbsp;{{vm.product.minOrderAmount}}",
		"Reservation time": "Gereserveerd sinds",
		"Reservation time:": "Gereserveerd sinds:",
		"Reserved products at Febelco": "Gereserveerde producten bij Febelco",
		"Reserveer nu uw griep vaccins": "Reserveer nu uw griep vaccins",
		"Reset": "Wissen",
		"Retroactive discount": "Retroactieve korting",
		"Return": "Terug",
		"Return to the homepage": "Terug naar de homepagina",
		"Route number": "Route nummer",
		"Running low on stock!": "Bijna op!",
		"Save": "Bewaren",
		"Scientific notices": "Wetenschappelijke bijsluiter",
		"Search": "Zoeken",
		"Search by contract name": "Zoek op naam contact",
		"Search by name": "Zoek op naam",
		"Search by name or number": "Zoek op productnaam of Productnummer",
		"Search products by number or name": "Zoek producten op Productnummer of naam",
		"See the latest discounts": "Bekijk de laatste kortingen",
		"Select Decade": {
			"Datetimepicker tooltips": "Selecteer decennium"
		},
		"Select Month": {
			"Datetimepicker tooltips": "Selecteer maand"
		},
		"Select Year": {
			"Datetimepicker tooltips": "Selecteer jaar"
		},
		"Select other pharmacy": "Selecteer andere apotheek",
		"Select other seller": "Selecteer andere aanbieder",
		"Select wholesaler": "Selecteer een groothandel",
		"Seller": "Aanbieder",
		"Sellers": "Aanbieders",
		"Send a fax to": "Fax naar",
		"Send an e-mail to": "Mail naar",
		"Send application": "Verstuur aanvraag",
		"Sent to seller": "Verstuurd naar aanbieder",
		"Serialnumber": "Serienummer",
		"Shipping note": "Zendnota",
		"Shopping cart": "Winkelmand",
		"Show all": "Toon alle",
		"Show all results": "Toon alle resultaten",
		"Show in grid": "Toon in rooster",
		"Show in list": "Toon in lijst",
		"Show less": "Toon minder",
		"Side effects": "Bijwerkingen",
		"Sign out": "Afmelden",
		"Sold out!": "Te laat!",
		"Something went wrong": "Er liep iets mis",
		"Something went wrong when loading this page.": "Er liep iets mis bij het inladen van deze pagina.",
		"Something went wrong while adding the products to your shoppingcart.": "Er liep iets mis. De producten konden niet toegevoegd worden aan uw winkelmand.",
		"Something went wrong while adding your products, please try again.": "Er liep iets mis. De producten konden niet toegevoegd worden. Gelieve opnieuw te proberen.",
		"Something went wrong with the import of your file. Please check your CSV and try again.": "Er liep iets mis bij het importeren van het bestand. Gelieve het CSV-bestand te controleren en opnieuw te proberen.",
		"Sort": "Sorteer",
		"Sort by": "Sorteer op",
		"Special Discounts": "Speciale kortingen",
		"Special order possible": "Speciale bestelling mogelijk",
		"Special orders": "Speciale bestellingen",
		"Status": "Status",
		"Stock response cannot be checked at the moment.": "De voorraad kan momenteel niet opgevraagd worden.",
		"Street": "Straat",
		"Subtotal": "Subtotaal",
		"Suggesties": "Suggesties",
		"Supplier": "Leverancier",
		"Supplier has no stock available": "Niet voorradig bij leverancier",
		"Supplier reference": "Leverancier ID",
		"TO-nr.": "TO-bonnr.",
		"Tags": "Labels",
		"Tax": "BTW",
		"Tel:": "Tel:",
		"Telephone number": "Telefoonnummer",
		"Thank you for ordering": "Bedankt voor uw bestelling",
		"The Agios discount is not known, contact the supplier for more info.": "De Agios korting is niet gekend, voor meer info hierover, contacteer de leverancier.",
		"The CSV was empty.": "Het CSV-bestand is leeg. Gelieve dit te controleren en opnieuw te proberen.",
		"The last 3 months you did not submit any rental applications via Profficina.": "U heeft de voorbije 3 maand geen huuraanvraag gedaan via Profficina.",
		"The last 3 months, you ended rent for more than 15 products.": "U heeft de huur stopgezet van meer dan 15 producten de afgelopen 3 maanden.",
		"The orders could not be retrieved": "Er ging iets mis tijdens het ophalen van de bestellingen",
		"The partnerships could not be retrieved": "Er ging iets mis tijdens het ophalen van de partners",
		"The product could not be added to your shopping cart": "Het product kon niet toegevoegd worden aan uw winkelmand",
		"The product could not be removed from your shopping cart": "Het product kon niet verwijderd worden uit uw winkelmand",
		"The product quantity could not be updated": "De product hoeveelheid kon niet aangepast worden",
		"The product you were looking was not found or is inactive.": "Het product dat u wou bekijken is niet meer actief.",
		"The products cannot be retrieved.": "Er liep iets mis met het ophalen van de producten.",
		"The products could not be removed from your shopping cart": "De producten konden niet verwijderd worden uit uw winkelmandje.",
		"The quantity of one or more products is incorrect.": "Bij één of meerdere producten werd geen correct aantal ingegeven.",
		"The shaded products can no longer be ordered.": "De gearceerde producten kunnen niet langer besteld worden.",
		"There are currently no discounts available": "Er zijn geen kortingen beschikbaar.",
		"There are currently no products available": "Er zijn geen producten beschikbaar.",
		"There are still products in your shopping cart": "Er zitten nog producten in uw winkelmand",
		"This product is in Agios, the discount displayed is not the Agios discount.": " Dit product zit in Agios, de getoonde korting is geen Agios korting.",
		"This promopack contains following products": "Dit promopack bevat de volgende producten",
		"Time": "Tijdstip",
		"To TGZ homepage": "TGZ Homepagina ",
		"Too many results.": "Meer dan 20 resultaten.",
		"Total": "Totaal",
		"Total (incl. VAT)": "Totaal (incl. BTW)",
		"Total discount": "Totale korting",
		"Total quantity in panaché": "Totaal aantal producten in panaché",
		"Total rent": "Huurtotaal",
		"Trade in months after expiry": "Omruiltermijn na vervaldatum",
		"Trade in months before expiry": "Trade in months before expiry",
		"Trade in refund value": "Trade in refund value",
		"U heeft momenteel geen openstaande reservaties.": "U heeft momenteel geen openstaande reservaties.",
		"U heeft voor dit partnership een {{contract.name}} contract van onbepaalde duur vanaf {{contract.startDate | date}}": "U heeft voor dit partnership een {{contract.name}} contract van {{contract.startDate | date}} voor onbepaalde tijd.",
		"U heeft voor dit partnership een {{contract.name}} contract van {{contract.startDate | date}} tot {{contract.endDate | date}}": "U heeft voor dit partnership een {{contract.name}} contract van {{contract.startDate | date}} tot en met {{contract.endDate | date}}",
		"Undo changes": "Wijzigingen ongedaan maken",
		"Unfortunately there are no products available for the current criteria.": "Er zijn geen producten beschikbaar voor de geselecteerde criteria.",
		"Unfortunately there were no certificates found.": "Er zijn momenteel geen certificaten beschikbaar.",
		"Unfortunately there were no items found from Profficina.": "U hebt nog geen huuraanvraag gedaan via Profficina.",
		"Unfortunately there were no news items found.": "Er zijn geen nieuwsberichten beschikbaar.",
		"Unfortunately there were no partnerships found.": "Er zijn geen partners gevonden.",
		"Unfortunately there were no rental products found.": "Er zijn geen huurproducten teruggevonden.",
		"Unfortunately there were no rental requests found.": "Er zijn geen huuraanvragen teruggevonden.",
		"Until": "Tot",
		"Up to": "Tot",
		"Update cart": "Winkelmand aanpassen",
		"Update shopping cart [ENTER]": "Winkelmand bijwerken [ENTER]",
		"Updating your cart...": "Winkelmand aan het bijwerken...",
		"Usage": "Gebruik",
		"Uw aanvraag": "Uw aanvraag",
		"Uw contract": "Uw contract",
		"Uw gereserveerde griepvaccins zijn toegevoegd aan onderstaande lijst van reservaties echter kunnen we geen nieuwe reservaties meer opnemen.": "Uw gereserveerde griepvaccins zijn toegevoegd aan onderstaande lijst van reservaties echter kunnen we geen nieuwe reservaties meer opnemen.",
		"Uw huuraanvraag": "Uw huuraanvraag",
		"Uw huuraanvraag is verstuurd naar de klantendienst.": "Uw huuraanvraag is verstuurd naar de klantendienst.",
		"VAT": "BTW",
		"VAT:": "Btw:",
		"VAXIGRIP TETRA 2020-2021 0,5 ML 1 WWSP": "VAXIGRIP TETRA 2020-2021 0,5 ML 1 WWSP",
		"Valid from": "Geldig van",
		"Valid from - until": "Geldig van - tot",
		"Valid until": "Geldig tot",
		"Vendor": "Aanbieder",
		"Verstuur": "Verstuur",
		"Verzending": "Verzending",
		"View my orders": "Bestellingen bekijken",
		"View my packages": "Mijn verzendingen bekijken",
		"View my rent overview": "Mijn huuroverzicht bekijken",
		"View my reservations": "Reservaties bekijken",
		"View your shopping basket": "Bekijk uw winkelmand",
		"Voor vragen of aanpassingen aan deze aanvraag, gelieve de klantendienst te contacteren op 03/770.70.70 of klantendienst@febelco.be": "Voor vragen of aanpassingen aan deze aanvraag, gelieve de klantendienst te contacteren op 03/770.70.70 of klantendienst@febelco.be",
		"We can not find the page you are looking for. The product / news item / ... may no longer exist.": "We kunnen de pagina die u zoekt niet vinden. Mogelijks bestaat het product/nieuwsbericht/… niet meer.",
		"Weight": "Gewicht",
		"What would you like use to do <strong>when these products are not in stock</strong>?": "WAT WENST U TE DOEN <strong>INDIEN DIT ZICH VOORDOET?</strong>",
		"Wholesaler": "Groothandel",
		"Width": "Breedte",
		"U kan uw vaccins uitsluitend reserveren via Profficina. We bevelen u van harte aan om uw aantallen goed in te schatten, zodat we op basis daarvan voldoende voorraad kunnen voorzien.": "U kan uw vaccins uitsluitend reserveren via Profficina. We bevelen u van harte aan om uw aantallen goed in te schatten, zodat we op basis daarvan voldoende voorraad kunnen voorzien.",
		"Wij raden aan om\n                                            hierbij ook deze producten te huren": "Wij raden aan om hierbij ook deze producten te huren",
		"Wij raden aan om\n                                            hierbij ook deze producten te kopen": "Wij raden aan om hierbij ook deze producten te kopen",
		"Wij raden aan om hierbij ook deze producten te huren": "Wij raden aan om hierbij ook deze producten te huren",
		"Wij raden aan om hierbij ook deze producten te kopen": "Wij raden aan om hierbij ook deze producten te kopen",
		"Withdrawn product": "Product uit handel",
		"Maximum quantity exceeded.": "Maximum quantity exceeded.",
		"Year": "Jaar",
		"Yes": "Ja",
		"You are logged in with pharmacy": "U bent aangemeld met apotheek",
		"You are logged in with seller": "U bent aangemeld met aanbieder",
		"You are now logged in with pharmacy": "U bent nu aangemeld met apotheek",
		"You can choose from the following products:": "U heeft de keuze uit volgende producten:",
		"You currently do not rent products from Febelco.": "U huurt momenteel geen producten van Febelco.",
		"You did not update your cart with the quantities you last modified.": "U heeft uw winkelmand nog niet bijgewerkt met de laatst gewijzigde aantallen.",
		"You do not have permission to view this page.": "U heeft geen toestemming om deze pagina te bekijken.",
		"You have more than 15 rental products in your possession.": "U heeft meer dan 15 huurproducten in uw bezit.",
		"You have more than 15 rental requests in the last 3 months.": "U heeft de laatste 3 maanden huur aanvragen ingedient.",
		"You have not rented products from Febelco.": "U heeft geen producten gehuurd bij Febelco.",
		"You searched for": "Uw zoekresultaten voor",
		"You will receive an email confirmation shortly at {{ vm.mail }}.": "Een bevestiging van uw bestelling werd gemaild naar {{ vm.mail }}.",
		"Your browser does not support file upload.": "Uw browser ondersteunt de bestand-opladen functionaliteit niet.",
		"Your info": "Uw gegevens",
		"Your purchases": "Uw aankopen",
		"Your recent rental requests": "Recente huuraanvragen via Profficina",
		"Your rent request on": "Aanvraag van",
		"Your reservation has been confirmed.": "Uw reservatie van griepvaccins werd goed bewaard.",
		"Your search value": "Uw zoekterm",
		"Your shopping cart": "Uw winkelmand",
		"_myDocuments._reportNarcotics.description": "Hier krijgt u een overzicht van alle producten (met stoffen opgelijst in bijlagen I, II en IV van het K.B. 06/09/2017) waarvoor we nog geen verdovingsbon van u mochten ontvangen.",
		"_myDocuments._reportNarcotics.title": "Openstaande verdovingsbonnen",
		"_myDocuments._reportPurchaseProposals.description": "Dit rapport geeft u een mooi overzicht van uw aankopen en geeft duidelijk weer – per CNK – hoeveel stuks (1/5/10 st.) u het best aankoopt om van een maximale korting te kunnen genieten. Het helpt u ook het aantal inkomende leveringen van eenzelfde CNK binnen eenzelfde facturatieperiode te beperken, en draagt dus bij tot een hogere efficiëntie.",
		"_myDocuments._reportPurchaseProposals.title": "Aankoopvoorstellen",
		"_myDocuments._settings.introText": "Hier krijgt u een overzicht van uw openstaande verdovingsbonnen en uw aankoopvoorstellen.",
		"_myDocuments._settings.myDocuments": "Mijn documenten",
		"_myDocuments._settings.viewMyDocuments": "Documenten bekijken",
		"_myDocuments._siteHeader.myDocuments": "Mijn documenten",
		"_myDocuments.downloadDocument": "Download document",
		"_myDocuments.myDocuments": "Mijn documenten",
		"_selftests.linkToFaq": "Voor al uw vragen met betrekking tot de COVID testkit, gelieve contact op te nemen met uw relatiebeheerder.",
		"_reservationCampaigns.product": "Product",
		"_reservationCampaigns.productNumber": "CNK",
		"_reservationCampaigns.quantity": "Aantal",
		"_reservationCampaigns.reservationConfirmed": "Uw reservatie werd goed ontvangen.",
		"_reservationCampaigns.save": "Bewaren",
		"_reservationCampaigns.totalLimitReached": "Reservatielimiet bereikt.",
		"_reservationCampaigns.limitReached": "Maximum {{limit}} st.",
		"article": [
			"artikel",
			"artikels"
		],
		"at": {
			"delivered on april 14th AT 17:25": "om"
		},
		"can be delivered on": "levering mogelijk op",
		"certificate": [
			"document gevonden",
			"documenten gevonden"
		],
		"checkout.agreeWithTerms": "Door op ‘Bestelling bevestigen’ te klikken, stemt u in met de <a href=\"http://www.profficina.be/nl/algemene-voorwaarden.html\" class=\"link link-primary\" target=\"_blank\">algemene gebruiksvoorwaarden van Profficina</a>.",
		"checkout.contactSupportWhenInvoiceAddressIsIncorrect": "Contacteer <a href=\"mailto:support@profficina.be\">support@profficina.be</a> als deze informatie incorrect is.",
		"checkout.linkToOrderOverview": "U kan op elk moment de status en details van uw bestellingen bekijken via 'Mijn account' <i class=\"ico ico-angle-right\"></i> '<a ui-sref=\"order-overview\" class=\"link link-primary\">Mijn bestellingen</a>' in het menu bovenaan de pagina.",
		"contact": "contact",
		"contract": "contract",
		"contracts": "contracts",
		"discount": "korting",
		"discounts": "kortingen",
		"documents": "documenten",
		"indefinite": "voor onbepaalde tijd",
		"indefinitely": "voor onbepaalde tijd",
		"news": "nieuws",
		"no": "nee",
		"or Send an email to": "of mail naar",
		"parcel.addAnotherLine": "Pakket toevoegen",
		"parcel.addConfirmationExplanations": "Een woordje uitleg wat men nu moet doen   ... Text TBD",
		"parcel.allMyParcels": "Al mijn verzendingen",
		"parcel.back": "Vorige",
		"parcel.backToOverview": "Terug naar overzicht",
		"parcel.barcode": "Barcode",
		"parcel.cancel": "Verzending annuleren",
		"parcel.cancelParcel": "Pakket annuleren",
		"parcel.checkData": "Controleer de gegevens en duid aan dat u akkoord gaat met",
		"parcel.confirmOrder": "Verzending bevestigen",
		"parcel.createALabelHere": "Maak hier een verzendlabel aan",
		"parcel.createParcel": "Verzending aanmaken",
		"parcel.createShippingLabelHere": "Pakket versturen naar een apotheek via Febelco? Maak hier een verzendlabel aan.",
		"parcel.customerNumber": "Klantnummer Febelco",
		"parcel.deliveredWithin48": "Binnen 48u geleverd op bestemming",
		"parcel.enterLicenseNumberLong": "Geef vergunningsnummer in van de apotheek waarvoor uw pakket bestemd is. Het adres van de bestemmeling zal automatisch op het volgende scherm verschijnen.",
		"parcel.enterLicenseNumberShort": "Gelieve vergunningsnummer in te geven.",
		"parcel.febelcoNotResponsibleForContent": "Febelco is niet verantwoordelijk voor de inhoud van de pakketten.",
		"parcel.followWithTrackAndTrace": "Volg via Track & Trace",
		"parcel.giveParcelToCourier": "Geef uw pakket met label aan de Febelco koerier",
		"parcel.hereYouCanRegister": "Hier kan u verzendingen naar andere apotheken via Febelco aanvragen en kan u de status van die verzendingen opvolgen.",
		"parcel.howDoesItWork": "Hoe werkt het?  ..TBD",
		"parcel.iAgreeToTheTerms": "Ik ga akkoord met de voorwaarden.",
		"parcel.latestShipments": "Verzendingen van de laatste 6 maanden",
		"parcel.licenseNumber": "Vergunningsnummer",
		"parcel.licenseNumberShort": "Vergunningsnr.",
		"parcel.isSigned": "Handtekening ontvangen",
		"parcel.insurance": "Verzekering",
		"parcel.insuranceDescription": "Prijs € {{ insurancePrice }} . Als het pakje verzekerd is, dan wordt er ook een handtekening gevraagd bij ontvangst.",
		"parcel.required": "Verplicht",
		"parcel.packageValue": "Waarde van het pakket",
		"parcel.packagePrice": "Pakket prijs: ",
		"parcel.packageDiscount": "Pakket korting: ",
		"parcel.insuranceInvoiceAmount": "Aangerekende prijs voor verzekering:",
		"parcel.packageInvoiceAmount": "Aangerekende prijs voor het pakket: ",
		"parcel.freePackage": "Dit pakket is gratis, een eventuele bijkomende verzekering wordt altijd aangerekend.",
		"parcel.line": [
			"pakket",
			"pakketten"
		],
		"parcel.madeOn": "Aangemaakt op",
		"parcel.myParcels": "Mijn verzendingen",
		"parcel.nameApbOrCustomerNr": "Naam, apb-nr, klantnr.",
		"parcel.next": "Volgende",
		"parcel.no": "Nee",
		"parcel.noParcelsFound": "Geen verzendingen gevonden.",
		"parcel.noParcelsFoundForCriteria": "Geen verzendingen gevonden voor ingegeven zoekcriteria.",
		"parcel.noPharmacyFound": "Geen apotheek gevonden met deze gegevens.",
		"parcel.orderNumber": "Verzending ID",
		"parcel.packLower": [
			"pakket",
			"pakketten"
		],
		"parcel.packages": "Pakketjes",
		"parcel.parcel": "Verzending",
		"parcel.parcelBarcode": "Barcode pakket",
		"parcel.parcelCancelCommandSent": "Even geduld aub, de annulatie van uw pakket of zending is in verwerking.",
		"parcel.errorSendingCancelCommand": "Er is iets fout gegaan bij het annuleren van uw pakket of verzending.",
		"parcel.parcelLower": [
			"verzending",
			"verzendingen"
		],
		"parcel.perPage": "per pagina",
		"parcel.pleaseAgreeToTerms": "Gelieve akkoord te gaan met de voorwaarden.",
		"parcel.pleaseSelectPackageType": "Please select a package type",
		"parcel.printAndHandToDriver": "Print de verzendlabels en geef het pakket mee met uw Febelco-chauffeur.",
		"parcel.printLabel": "Print verzendlabel",
		"parcel.remarkForCourier": "Opmerking / Bericht voor koerier",
		"parcel.remarkForCourierDescription": "Hier kan u extra informatie of instructies toevoegen voor de koerier.",
		"parcel.reset": "Wissen",
		"parcel.search": "Zoeken",
		"parcel.searchAllParcels": "Zoek een van uw verzendingen op of maak een nieuwe verzending aan.",
		"parcel.sendTo": "Verzenden naar",
		"parcel.sentTo": "Verstuurd naar",
		"parcel.shippingDetail": "Detail verzending",
		"parcel.shippingDetails": "Details verzending",
		"parcel.signatureRequired": "Aftekenen bij ontvangst",
		"parcel.signatureRequiredDescription": "Lorem ipsum dolor sit amet...",
		"parcel.theConditions": "de voorwaarden",
		"parcel.to": "Naar",
		"parcel.trackAndTraceInDetail": "Track & Trace activiteit in detail",
		"parcel.until": "tot",
		"parcel.viewMyParcels": "Mijn verzendingen bekijken",
		"parcel.whatCanBeSentAndHowItWorks": "Een woordje uitleg over wat men kan verzenden en hoe het werkt.",
		"parcel.whatToSend": "Wat wil u verzenden?",
		"parcel.whichPharmacyToSend": "Naar welke apotheek wilt u een pakket verzenden?",
		"parcel.yes": "Ja",
		"parcel.youHaveNoRecentParcels": "U heeft recent geen verzendingen geregistreerd",
		"parcel.yourParcelWasRegistered": "Uw verzending is geregistreerd",
		"partnerships": "partnerships",
		"pcs.": "st.",
		"per page": "per pagina",
		"product": [
			"product",
			"producten"
		],
		"product.medipim.expires": "Vervaldatum",
		"product.medipim.refundValueWithOmnio": "Omnio tarief",
		"product.medipim.refundValueWithoutOmnio": "Terugbetalingstarief",
		"product.medipim.tradeInMonthsAfterExpiry": "Ruilperiode na vervaldatum",
		"product.medipim.tradeInMonthsBeforeExpiry": "Ruilperiode voor vervaldatum",
		"product.status.active": "Actief",
		"product.status.inactive": "Niet actief",
		"product.status.replaced": "Vervangen",
		"products": "producten",
		"products available in your warehouse": "stuk(s) voorradig in uw vestiging",
		"products available": "stuk(s) voorradig",
		"public": "public",
		"refundOnDate": "op",
		"rental product": [
			"huurproduct",
			"huurproducten"
		],
		"rental request": [
			"huuraanvraag",
			"huuraanvragen"
		],
		"select file": "selecteer bestand",
		"tour": "toer",
		"until": "tot",
		"upward of": "vanaf",
		"v.a. {{d.amount}} st.": "va. {{d.amount}} st.",
		"vac test": "\"U kan uw vaccins vanaf nu uitsluitend reserveren via het aankoopplatform Profficina. Zo kan u ook makkelijk de kortingenper product raadplegen, en achteraf ook de aantallen die u gereserveerd heeft. Handig, niet?Nog geen Profficina-account? Neem dan snel contact op met uw vertrouwde relatiebeheerder, of met support@profficina.be.\"",
		"yes": "ja",
		"{{ vm.activeCategory ? vm.activeCategory.name : 'All rental products'}}": "{{ vm.activeCategory ? vm.activeCategory.name : 'Alle huurproducten'}}",
		"Contract details": "Details contract",
		"_order.selectAccountTitle": "Selecteer uw klantenrekening",
		"Dear Pharmacist,": "Beste apotheker,",
		"From 23/01/2023 <strong>you</strong> and anyone who gives you rights, <strong>can manage the reservations yourself</strong> via <a class=\"link\" target=\"_blank\" href=\"{{vm.myFebelcoLink}}\">MyFebelco</a>, our new customer portal: changing, removing or adding can then be done in a few mouse clicks.": "Vanaf 23/01/2023 <strong>beheren jij</strong> en iedereen die je rechten geeft, <strong>de reservaties gewoon zelf</strong> via <a class=\"link\" target=\"_blank\" href=\"{{vm.myFebelcoLink}}\">MyFebelco</a>, ons nieuw klantenportaal: wijzigen, verwijderen of toevoegen kan dan in enkele muisklikken.",
		"Via <a class=\"link\" target=\"_blank\" href=\"{{vm.myFebelcoLink}}\">MyFebelco</a> you also get direct access to all kinds of information, personal data and useful tools. Calling customer service is no longer necessary, so they have more time to help our customers on the line faster.": "Je krijgt via <a class=\"link\" target=\"_blank\" href=\"{{vm.myFebelcoLink}}\">MyFebelco</a> ook directe toegang tot allerhande info, persoonlijke data en nuttige tools. Bellen naar de klantendienst is niet meer nodig, zo hebben zij meer tijd vrij om onze klanten aan de lijn sneller verder te helpen.",
		"Due to this progress, the <strong>reservation overview</strong> will no longer be available on Profficina and your secure area (my Febelco) <strong>from 16/01</strong>.": "Omwille van deze vooruitgang zal het <strong>reservatie-overzicht niet meer beschikbaar</strong> zijn op Profficina en uw beveiligde zone (mijn Febelco) <strong>vanaf 16/01</strong>.",
		"<strong>Questions?</strong><br>Before you can go to MyFebelco, you must activate your account on the basis of a registration email.": "<strong>Vragen?</strong><br>Voor je op MyFebelco terecht kan, moet je je account activeren, op basis van een registratiemail.",
		"Didn't receive a registration email? Then contact <a href=\"mailto:support@myfebelco.be\" class=\"link\">support@myfebelco.be</a>.": "Geen registratiemail ontvangen? Contacteer dan <a href=\"mailto:support@myfebelco.be\" class=\"link\">support@myfebelco.be</a>."
	}
};


//////////////////
// WEBPACK FOOTER
// ./assets/po/nl.po
// module id = 685
// module chunks = 0